import { Badge } from "@/components/ui/badge"

const TONE: Record<string, "accent" | "signal" | "muted" | "solid" | "neutral"> = {
  active: "accent",
  grace: "signal",
  lapsed: "muted",
  revoked: "solid",
}

const LABEL: Record<string, string> = {
  active: "Active",
  grace: "Grace period",
  lapsed: "Lapsed",
  revoked: "Revoked",
}

export function LicenseStatusBadge({ status }: { status: string }) {
  return <Badge tone={TONE[status] ?? "neutral"}>{LABEL[status] ?? status}</Badge>
}
